"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustReason = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var TrustReason;
(function (TrustReason) {
    TrustReason["TrustedDomainBrowserUrl"] = "Trusted browser URL";
    TrustReason["TrustedDomainBrowserTabTitle"] = "Trusted browser tab title";
    TrustReason["TrustedBrowserTabInfos"] = "Trusted browser URL and/or tab title";
    TrustReason["TrustedDomainEmailRecipient"] = "Trusted email recipient";
    TrustReason["TrustedDomainCloudSyncUsername"] = "Trusted sync username";
    TrustReason["TrustedSlackWorkspace"] = "Trusted Slack workspace";
    TrustReason["EventPairingServiceMatch"] = "Event matched with cloud activity";
    TrustReason["EventPairingServiceEndpointMatch"] = "Event matched with endpoint activity";
    TrustReason["DownloadToAManagedDevice"] = "Download to a managed device";
    TrustReason["SharedWithTrustedUsers"] = "Shared with trusted users";
    TrustReason["TrustedBrowserUrlPath"] = "Trusted specific URL path";
    TrustReason["TrustedAccountName"] = "Trusted account";
    TrustReason["TrustedGitRepositoryUri"] = "Trusted Git repository (URI)";
    TrustReason["TrustedGitRepositoryDomain"] = "Trusted Git repository (Domain)";
    TrustReason["TrustedGitRepositoryUrlPath"] = "Trusted Git repository (Specific URL path)";
    TrustReason["LocalGitRepository"] = "Local Git repository on monitored endpoint";
    TrustReason["TrustedUsername"] = "Trusted Username";
    TrustReason["PasswordInput"] = "Pasted to password field";
    TrustReason["UsernameInput"] = "Pasted to username field";
    TrustReason["SameOrigin"] = "Copy/Pasted to same tab";
    TrustReason["TrustedRemoteHostname"] = "Trusted remote hostname";
})(TrustReason = exports.TrustReason || (exports.TrustReason = {}));
